import { Navigate, Route, Routes } from "react-router-dom";
import { UserDashboard } from "../../pages/account";
import { UserTickets } from "../../pages/account";

export const AccountRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UserDashboard />} />
      <Route path="/tickets" element={<UserTickets />} />
      <Route path="*" element={<Navigate to="/account" />} />
    </Routes>
  );
};
